export const queryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 0,
      useErrorBoundary: true,
    },
  },
};
